const functionScrollToTop = (topOffset = 0) => {
    window.scrollTo({
        top: topOffset,
        left: 0,
        behavior: 'smooth'
    })
}

const handleScrollToId = (id, offset = 0) => {
    const header = document.querySelector('header');
    const offsetFinal = header ? (header?.offsetHeight + offset) : offset;

    const element = document.querySelector(id?.startsWith('#') ? id : `#${id}`);
    if (!element) return;

    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - offsetFinal;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
};

export {
    functionScrollToTop,
    handleScrollToId
}
